import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    event: String
  }

  connect() {
    if (!this.hasEventValue) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': this.eventValue
    })

    // Remove the element to prevent duplicate events if cached or re-rendered
    this.element.remove()
  }
}
